import { useSyncExternalStore } from "react";

// Shared UI overlay flags. Any full-screen or important overlay
// (KYC modal, desktop user panel, filters panel) can flip these so
// floating widgets (Bera IA) know to hide themselves.
type OverlayState = {
  kycOpen: boolean;
  desktopMenuOpen: boolean;
  filtersOpen: boolean;
};

let state: OverlayState = {
  kycOpen: false,
  desktopMenuOpen: false,
  filtersOpen: false,
};
const listeners = new Set<() => void>();

function emit() {
  listeners.forEach((l) => l());
}

function setKey<K extends keyof OverlayState>(key: K, value: OverlayState[K]) {
  if (state[key] === value) return;
  state = { ...state, [key]: value };
  emit();
}

export const kycUiStore = {
  setOpen(open: boolean) {
    setKey("kycOpen", open);
  },
  setDesktopMenuOpen(open: boolean) {
    setKey("desktopMenuOpen", open);
  },
  setFiltersOpen(open: boolean) {
    setKey("filtersOpen", open);
  },
  getSnapshot() {
    return state.kycOpen;
  },
  getAnyOverlaySnapshot() {
    return state.kycOpen || state.desktopMenuOpen || state.filtersOpen;
  },
  subscribe(listener: () => void) {
    listeners.add(listener);
    return () => listeners.delete(listener);
  },
};

export function useKycModalOpen(): boolean {
  return useSyncExternalStore(kycUiStore.subscribe, kycUiStore.getSnapshot, () => false);
}

export function useAnyOverlayOpen(): boolean {
  return useSyncExternalStore(
    kycUiStore.subscribe,
    kycUiStore.getAnyOverlaySnapshot,
    () => false,
  );
}
